
const initState = {
    AdminUserList:[],
    status:'init',
    message: null
}

export default function adminUserReducer (preState=initState,action){
    switch (action.type) {
        case 'GET_ADMIN_USER_SUCCESS':
            return {
                ...preState,
                AdminUserList:action.payload,
                status:'success',
                message: 'Successfully fetched'
            }
        case 'CREATE_ADMIN_USER_SUCCESS':
            return {
                ...preState,
                AdminUserList:action.payload,
                status:'success',
                message: 'Successfully created'
            }
        case 'UPDATE_ADMIN_USER_SUCCESS':
            return {
                ...preState,
                AdminUserList:preState.AdminUserList.map(admin => 
                    admin.account === action.payload.account  ? action.payload : admin
                ),
                status:'success',
                message: 'Successfully updated'
            }
        case 'DELETE_ADMIN_USER_SUCCESS':
            return {
                ...preState,
                AdminUserList:preState.AdminUserList.map(admin => 
                    admin.account === action.payload.account  ? action.payload : admin
                ),
                status:'success',
                message: 'Successfully deleted'
            }
        case 'ADMIN_USER_FAIL':
            return {
                ...preState,
                status:'error',
                message:action.payload
            }
        default:
            return preState
    }
}